import IncidentAppointmentTypes from "../../../../../../Types/IncidentAppointmentTypes"

let incidentAppointmentParams: IncidentAppointmentTypes | any = {
    IncidentMedicalAppointmentId: null,
    IncidentId: null,
    AppointmentDateUTC: null,
    AppointmentDesc: null,
    CreatedDateUTC: null,
    CreatedBy: null,
    ModifyDateUTC: null,
    DeletedDateUTC: null,
    DisabledDateUTC: null
}
export default incidentAppointmentParams